module.exports = __webpack_public_path__ + "static/img/nao.d59772b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/nao.png
// module id = tkq4
// module chunks = 1